<template>
    <div class="form">
        <div> <h3> Engangsfuldmagt</h3>
        </div>
        <div>
            <p class="p">Med en engangsfuldmagt giver du tilladelse til, at GLS må levere din pakke uden<br>  kvittering på det af dig
                angivne sted (f.eks. legehus, carport eller lign.) <br>  </p>
            <p v-if="!closed" class="p" >Engangsfuldmagten kan laves fra du modtager dit pakkenummer fra<br>  din afsender, og indtil din pakke bliver læsset på GLS-bilen.</p>
            <p class="p">Denne leveringstype egner sig ikke til etageejendomme med aflåst opgang.</p>
        </div>

<div class="fuldmagt-info">
    <tippy
            interactive
            :animate-fill="false"
            placement="bottom"
            distant="7"
            theme="light"
            animation="fade"
            trigger="click"
            arrow>
        <template v-slot:trigger>

            <p class="p" style="display: flex">Her kan du læse mere om engangsfuldmagt. <img style="margin-left: 4px" height="16" width="16" alt="Hvad er engangsfuldmagt?" src="../assets/infoikon.svg"  /> </p>

        </template>
        <span>
  <p class="p">Det er nemt at udstede en engangsfuldmagt til GLS, så du kan få leveret din pakke på din adresse, når du ikke er tilgængelig til at kvittere for pakken.</p>
<p class="p">Du skal blot udfylde feltet med <strong>pakkenummer</strong>, og <strong>postnummer</strong>, og klikke på <strong>Bestil engangsfuldmagt.</strong></p>
            <p  class="p">Med en engangsfuldmagt til GLS betragtes pakken som korrekt leveret, når chaufføren har stillet din pakke på det aftalte sted.</p>
<p class="p">Har du flere pakker, skal du lave en engangsfuldmagt pr. pakke.</p>
<p class="p">Når du har lavet en engangsfuldmagt, er den bindende.</p>
</span>
    </tippy>

</div>
        <P></P>
        <FormGroup>
            <TextInput
                    v-model="$v.parcel.parcelnumber.$model"
                    label="Pakkenr."
                    :max="12"
                    required
                    :error="$v.parcel.parcelnumber.$error"
                    error-message="Udfyld pakkenummer"
                    id="Pakkenr."


            />



        </FormGroup>



        <form-group>

            <TextInput
                    v-model="$v.parcel.zipcode.$model"
                    label="Postnr."
                    :max="4"

                    :error="$v.parcel.zipcode.$error"
                    :errorMessage="
          !$v.parcel.zipcode.required ? 'Udfyld postnr.' : ''
        "
                    required
                    id="Zipcode"
                    fullWidth

            />
        </form-group>
<br>
        <FormGroup>
            <Button  @click="submit"  class="blue"
                    :disabled="submitting">

                <span v-if="!submitting"> Bestil engangsfuldmagt </span>
                <span v-else>Validerer...</span>
            </Button
            >
        </FormGroup>

    </div>

</template>

<script>
    import TextInput from "@/components/TextInput.vue";
    import FormGroup from "@/components/FormGroup.vue";
    import Button from "@/components/Button.vue";
    //import {isChecked} from "../validators";
    import {
        required,
        numeric,
        minLength,
        maxLength
    } from "vuelidate/lib/validators";
    import { SignerService } from "../services/SignerService";

    export default {
        components: {
            TextInput,
            FormGroup,
            Button
        },
        props: ["parcel","closed"],
        data() {
            return {
                submitting:false,
            };

        },

        methods: {

            async submit() {

                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.submitting=true;

                    this.$emit('submitting',true);
                    const result = await SignerService.validateParcel({
                        parcelnumber: this.$v.parcel.parcelnumber.$model,
                        zipcode: this.$v.parcel.zipcode.$model
                    });

                    if (result.status===200)
                    {

                        if (result.data.statusCode==409)
                        {
                            this.$swal({
                                icon: 'error',
                                title: 'Din pakke '+ this.$v.parcel.parcelnumber.$model+ ' kan ikke valideres',
                                text: result.data.message,
                                footer: '',
                                confirmButtonColor: '#FFD100',
                                iconColor:'#da202a'


                            });
                            this.submitting=false;
                            this.$emit('submitting',false);
                        }
                       else if (result.data.statusCode==412)
                        {
                            this.$swal({
                                icon: 'error',
                                title: 'Din pakke '+ this.$v.parcel.parcelnumber.$model+ ' kan ikke valideres',
                                footer: '',
                                confirmButtonColor: '#FFD100',
                                iconColor:'#da202a',
                                html:
                                    '<p class="p">Af sikkerhedsmæssige årsager er din pakke blokeret! Ønsker du stadig en fuldmagt kan du udstede en på et stykke papir, som du hænger tilgængeligt for chaufføren. Dit navn og underskrift samt dato og pakkenr. skal fremgå af fuldmagten. Læs mere her  ' +
                                    '<a href="https://gls-group.eu/DK/da/fuldmagt">https://gls-group.eu/DK/da/fuldmagt.</a> </p>'


                            });
                            this.submitting=false;
                            this.$emit('submitting',false);
                        }
                        else if (result.data.statusCode==411)
                        {
                            this.$swal({
                                icon: 'error',
                                title: 'Din pakke '+ this.$v.parcel.parcelnumber.$model+ ' kan ikke valideres',
                                footer: '',
                                confirmButtonColor: '#FFD100',
                                iconColor:'#da202a',
                                html:
                                    '<p class="p">' +
                                    'Det er desværre ikke muligt at oprette en engangsfuldmagt – det kan være af følgende årsager:' +
                                    '</p>' +
                                    '<p></p>' +
                                    '<li class="p">Pakken er allerede på vej til dig *</li>' +
                                    '<li class="p">Pakken er bestilt til en GLS PakkeShop</li>' +
                                    '<li class="p">Pakken er bestilt til afhentning i en butik (Click&Collect)</li>' +
                                    '<li class="p">Din afsender har ved pakkens afsendelse valgt, at pakken må stilles.</li>' +
                                    '<li class="p">Pakken er en returpakke.</li>' +

                                    '<p class="p">' +
                                    '* Er din pakke på vej til levering til dig, kan du med fordel udstede en engangsfuldmagt på et stykke papir (med dit navn, pakkenummer, dato og din underskrift) og hænge den på ydersiden af din hoveddør. ' +
                                    '</p>' +
                                    '<p class="p">Alternativt kan du sende os en mail herom på dette link <a href="https://gls-group.eu/DK/da/engangsfuldmagt-manuel">https://gls-group.eu/DK/da/engangsfuldmagt-manuel.</a></p>'+
                                    '<p class="p">Læs mere her <a href="https://gls-group.eu/DK/da/fuldmagt">https://gls-group.eu/DK/da/fuldmagt.</a></p>'

                            });
                            this.submitting=false;
                            this.$emit('submitting',false);
                        }
                        else
                        {
                            localStorage.setItem("parcel",JSON.stringify(this.parcel));
                            this.$router.push("/bestilling");
                        }

                    }
                    else
                        this.$swal({
                            icon: 'error',
                            text: 'Der er desværre gået noget galt, prøv igen!',
                            footer: '',
                            iconColor:'#da202a'
                        });
                    this.submitting=false;
                    this.$emit('submitting',false);
                }

            }
        },
        validations: {
            parcel: {
                parcelnumber: {
                    required
                },

                zipcode: {
                    required,
                    numeric,
                    minLength: minLength(4),
                    maxLength: maxLength(4)
                },

            }
        }
    };
</script>
<style lang="scss" >

    button {
        overflow: visible;
        width: auto;
    }
    .p{

    font-size: 11px;
        text-align: left;
        font-family: "NewsonGLS-Regular", Verdana, sans-serif;
    }
    .orderButton
    {

        width: 140px;
        height: 50px;
        background: #FFD100;
        border-radius: 45px;
        margin-left:auto;
    }

    .title1{
        color: #172154;

    }
    .parcel-header{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .fuldmagt-info{
        display: flex;
        flex-direction: column;

    }
    .wrapper{
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        border-radius: 0px 0px 10px 10px;
        @media screen and(min-width:800px) {
            width: 100%;
            display: flex;
            justify-content: center;
            border: 1px solid #d6d6d6;
            padding: 38px;
            box-shadow: #d6d6d6 0px 0px 30px
        }
    }
    .main {
        max-width: 800px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .image-holder2{
            border-radius: 10px 10px 0px 0px;
            width:800px;
            @media screen and (max-width: 800px) {
                width:100%;
            }
        }

        .logo {
            max-width: 200px;

            display: flex;
            flex-direction: column;
            @media screen and(max-width: 800px){
                flex-direction: row;
            }


            img {
                width: 100%;
            }
            @media screen and (max-width: 1080px) {
                max-width: 600/19.2 * 1vw;
            }
            @media screen and (max-width: 800px) {
                display: flex;
                justify-content: center;
                width: 100%;
                max-width: 100%;
                max-width: 100%;
                img {
                    width: 50%;
                }
            }
        }
    }




</style>